import React from 'react';
import NavBar from './NavBar.jsx';
import ReactDOM from 'react-dom';

import Ajax from './AJAX.jsx';
import InteractiveTable from './InteractiveTable.jsx';
import * as tools from "./tools.jsx";

import UpdateDataForm from './UpdateDataForm.jsx';
import {DropDownMultiSelector} from "./DropDownSelector.jsx";
import {PlaylistCompsEditor} from "./playlistCompsEditor.jsx";
import {ConfirmModal} from "./ConfirmModal.jsx";

class PlaylistList extends React.Component {
   constructor(props)
   {
      super(props);
      this.state = {
         data_playlists: [],
         data_contexts: [],
         data_users: [],
         data_comps: [],
         hasTriedReadingData: false,
      }
      this.state.playlists = [];

      this.extraBtns = [
         {name:'edit', click: this.clickedEdit.bind(this)},
         {name:'remove', click:this.removePlaylist.bind(this)}
      ];

   
   }

   componentDidMount()
   {
      this.readDataIfNotReadAndUserExists();
   }

   readDataIfNotReadAndUserExists()
   {
     if(this.props.user)
      {
         if(!this.state.hasTriedReadingData)
         {
            this.props.appCallbacks.performAjaxRequest("playlists", "GET", null,
                tools.getSetBaseDataFunc(this, "data_playlists"), false);

            this.props.appCallbacks.performAjaxRequest("compositions", "GET", null,
                tools.getSetBaseDataFunc(this, "data_comps"), false);


            this.props.appCallbacks.performAjaxRequest("contexts", "GET", null,
               tools.getSetBaseDataFunc(this, "data_contexts"), false);

            this.props.appCallbacks.performAjaxRequest("users", "GET", null,
               tools.getSetBaseDataFunc(this, "data_users"), false);
            
            this.setState({hasTriedReadingData:true});
         }
      }
   }

   forceRefreshData() {
      this.setState({hasTriedReadingData:false});
      this.readDataIfNotReadAndUserExists();
   }
   getInterpreter()
   {
      const getContext = (id)=>this.state.data_contexts.find((c)=>c.context_id==id);
      const getUser = (id)=>this.state.data_users.find((u)=>u.user_id==id);
      return (
      {
         user_id:(id)=>{const user = getUser(id) ; return user ? user.name : id;},
         context_id:(id)=>{const context = getContext(id) ; return context ? context.name : id;},
         comps:(ids)=>{return ids.length},
         //context_id:(id)=>"OLE!" + this.state.data_contexts[0].name,
      });
   }

   clickedEdit(playlist)
   {
      this.showEditPlaylist(playlist, true)
   }
      
   showEditPlaylist(pl, listExists)
   {
      const self = this;
      
      const onSaveEdit = (editedPl) =>
      {
         if(editedPl != null)
         {
            //Check if context is available to selected user
            const plUser = self.state.data_users.find((u)=>u.user_id == editedPl.user_id);

            const selectedContext = self.state.data_contexts.find((c)=>c.context_id == editedPl.context_id);
            
            if(!plUser.contexts.find((cId)=>cId == editedPl.context_id))
            {
               const err ="Composition context set to: " + selectedContext.name +
                  " which is unavailable to user: " + plUser.name;
               
               self.props.appCallbacks.showMsg("Error", err);
               return;
            }

            const donePuttingOrPostingPlaylist = (response) =>
            {
               console.log("Done putting new values with response: ", response);
               if(response.success)
               {
                  self.props.appCallbacks.popModal();
               
                  self.forceRefreshData();
               }
               else
               {
                  self.props.appCallbacks.showResponseErr(response, "Add / Edit Playlist");
               }
            }

            if(listExists) {
               console.log("Putting playlist: ", editedPl);
               self.props.appCallbacks.performAjaxRequest('playlists/' + editedPl.playlist_id, "PUT", editedPl, donePuttingOrPostingPlaylist, false);
            }
            else
            {
               console.log("Posting playlist: ", editedPl);
               self.props.appCallbacks.performAjaxRequest('playlists', "POST", editedPl, donePuttingOrPostingPlaylist, false);
            }
         }
         else {
            self.props.appCallbacks.popModal();
         }
      }
      

      

      var drawFunctions =
      {
         context_id:DropDownMultiSelector,
         user_id:DropDownMultiSelector,
         //comps:DropDownMultiSelector,
         //position:DrawPosition,
          comps: PlaylistCompsEditor,
          playlist_id:tools.FreezeElement
      };
      
      const contextObjects = this.state.data_contexts.map((con)=>{return({id:con.context_id, name:con.name})});
      const userObjects = this.state.data_users.map((u)=>{return({id:u.user_id, name:u.name})});
      const compObjects = this.state.data_comps.map((com) =>{return({id:com.composition_id, name:com.name})});

      var drawFuncObjects =
      {
         user_id:{objects: userObjects, selectSingle:true},
         context_id:{objects: contextObjects, selectSingle:true},
         comps: {appCallbacks: this.props.appCallbacks},
         //comps: {objects: compObjects, value:pl.comps.map((c)=>{return c.composition_id}), selectSingle:false},
      };         

      
      var modalProps = {
         saveCallback:onSaveEdit,
         heading:"Edit Playlist Data",
         //errorMsg: error,
         data:pl,
         drawFuncs:drawFunctions,
         drawFuncObjects:drawFuncObjects,
      };

      this.props.appCallbacks.pushModal({modalClass:UpdateDataForm, modalProps:modalProps});
      
   }

      
   removePlaylist(pl){
      const self = this;

      const onConfirmDelete = ()=>
      {
         const onServerDelete = (response)=>
         {
            if(response.success)
            {
               self.forceRefreshData();
            }
            else
            {
               self.props.appCallbacks.showResponseErr(response, "Removing playlist error");
            }
         }
         self.props.appCallbacks.performAjaxRequest("playlists/" + pl.playlist_id, "DELETE", null,
            onServerDelete, false);
      }
      const modalProps = {
         heading: "Confirm Delete",
         msg:"Delete Playlist: " + pl.name + " ?",
         onConfirm:onConfirmDelete,
         popModal: self.props.appCallbacks.popModal,
      }
      self.props.appCallbacks.pushModal({modalClass:ConfirmModal, modalProps:modalProps});
   }

   clickedAddNew()
   {
      const newPlaylistData = {
         name:"Titel",
         description: "",
         user_id: this.props.user.user_id,
         context_id: this.props.user.contexts[0],
         comps:[],
      }

      this.showEditPlaylist(newPlaylistData, false);
   }

   render() {
      var tableStyle1 = {
         background: '#DDDDDD',
         padding: 5 
      }
      
      var tableStyle2 = Object.assign({},tableStyle1);

      tableStyle2.background = '#F0F0F0';

      const searchFilteredPlaylists = this.props.pageData.restrictions ?
         tools.filterArrayWhereAllRestrictionsMet(this.state.data_playlists, this.props.pageData.restrictions) :
         this.state.data_playlists;

      return (
         <div>
            <h1>Playlists </h1>
            <button onClick={this.clickedAddNew.bind(this)}>Add Playlist</button>
            <InteractiveTable extraBtns={this.extraBtns} interpreter={this.getInterpreter()} rowObjects={searchFilteredPlaylists/*this.state.data_playlists*/} />
         </div>
      );
   }
}

export default PlaylistList ;


// WEBPACK FOOTER //
// ./js/playlistList.jsx